module.exports = __webpack_public_path__ + "media/images/scribe-course-small-8977ba5e.png";